import { AxiosError, AxiosResponse } from 'axios'
import { QueryFunctionContext } from '@tanstack/react-query'
import { getInstance } from './instance'
import { WithRecordResponse } from '../models/Response'
import { ConversionStatusFilter } from '../models/List'
import {
  CmpConversion,
  Conversion,
  CmpConversionSelectItem,
} from '../models/Conversion'
import {
  getConversionListKey,
  getConversionsByIdsForCmpKey,
  getSelectConversionsListForCmpKey,
} from './queryKey'

export const getConversionStatusList = async () => {
  try {
    const response: AxiosResponse<
      WithRecordResponse<ConversionStatusFilter[]>
    > = await getInstance().get('/v3/conversion/static/conversion-status')
    return response.data.data
  } catch (e) {
    return Promise.reject((e as AxiosError).response?.data)
  }
}

export const getConversionList = async ({
  pageParam = 1,
  queryKey,
}: QueryFunctionContext<
  ReturnType<typeof getConversionListKey['keys']>
>): Promise<WithRecordResponse<Conversion[]>> => {
  const {
    typeIds,
    statusIds,
    conversionIds,
    postbackPartnerIds,
    searchField,
    limit,
    sortBy,
  } = queryKey[0] || {}
  try {
    const response: AxiosResponse<WithRecordResponse<Conversion[]>> =
      await getInstance().get('/v3/conversion/list', {
        params: {
          typeIds,
          statusIds,
          conversionIds,
          postbackPartnerIds,
          searchField,
          limit,
          sortBy,
          pageNo: pageParam,
        },
      })
    return response.data
  } catch (e) {
    return Promise.reject((e as AxiosError).response?.data)
  }
}

export const getConversionsByIdsForCmp = async ({
  queryKey,
}: QueryFunctionContext<
  ReturnType<typeof getConversionsByIdsForCmpKey['keys']>
>): Promise<WithRecordResponse<CmpConversion[]>> => {
  const { conversionIds } = queryKey[0] || {}
  try {
    const response: AxiosResponse<WithRecordResponse<CmpConversion[]>> =
      await getInstance().get('/v3/cmp/conversions/list', {
        params: {
          conversionIds,
        },
      })
    return (response.data?.data as any)?.conversionData
      ? {
          ...response.data,
          data: {
            ...response.data.data,
            data: (response.data.data as any).conversionData,
          },
        }
      : response.data
  } catch (e) {
    return Promise.reject((e as AxiosError).response?.data)
  }
}

export const getSelectConversionsListForCmp = async ({
  pageParam = 1,
  queryKey,
}: QueryFunctionContext<
  ReturnType<typeof getSelectConversionsListForCmpKey['keys']>
>) => {
  try {
    const {
      excludeConversionIds,
      owId,
      conversionTypeId,
      searchField,
      limit,
      sortBy,
    } = queryKey[0] || {}

    const response: AxiosResponse<
      WithRecordResponse<CmpConversionSelectItem[]>
    > = await getInstance().get('/v3/cmp/conversion/basic/list', {
      params: {
        excludeConversionIds,
        owId,
        conversionTypeId,
        searchField,
        limit,
        sortBy,
        pageNo: pageParam,
      },
    })
    return response.data
  } catch (err) {
    return Promise.reject((err as AxiosError).response)
  }
}
